import React, { Component } from 'react'
import Prefixer from 'inline-style-prefixer'
import PropTypes from 'prop-types'
import get_layout from '../util/get_layout'
import ReactDOM from 'react-dom'
let prefixer = new Prefixer()

export default class View extends Component {


  constructor(props) {
    super()

    this.state = {
      layout : {}
    }
  }

  static propTypes = {
    style: PropTypes.object
  }

  componentDidMount() {
    this.layoutHandle()
  }

  componentDidUpdate() {
    this.layoutHandle()
  }

  layoutHandle() {
    if (this.props.onLayout) {

      var layout = get_layout(ReactDOM.findDOMNode(this));
      var stateLayout = this.state.layout;
      if (stateLayout.x !== layout.x || stateLayout.y !== layout.y || stateLayout.width !== layout.width || stateLayout.height !== layout.height) {
        this.props.onLayout({nativeEvent: {layout}});
        this.setState({layout});
      }
    }
  }



  render() {

    let { style = {}, ...others } = this.props

    style.display = 'flex'
    if (style.flexDirection === 'row' && !style.height) {
      style.height = '100%'
    }
    if (!style.flexDirection) {
      style.flexDirection = 'column'
    }

    if (style.flexDirection === 'column' && style.height) {
      style.display = 'relative'
    }
    style = prefixer.prefix(style)
    return <div {...this.others} style={style}>
      {this.props.children}
    </div>
  }
}
